<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'recurringOrders.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="datatable-container">
      <div class="menuDisplayedColumns">
        <button mat-mini-fab color="primary" matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu">
          <mat-icon>list</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <div *ngFor="let displayedColumn of displayedColumnsMenu" cdkDrag>
              <section class="menu-item" (click)="$event.stopPropagation()">
                <ng-container *ngIf="displayedColumn.editable">
                  <mat-checkbox class="example-margin" [checked]="displayedColumn.selected"
                    (change)="onSelectMenu($event,displayedColumn.name)">
                    {{ 'recurringOrders.list.' + displayedColumn.name | translate }}
                  </mat-checkbox>
                </ng-container>
              </section>
            </div>
          </div>
        </mat-menu>

        <button class="refreshButton" mat-raised-button color="primary" (click)="getList()">Rafraichir</button>

        <button mat-icon-button color="primary" *ngIf="!filterForm.pristine" matTooltip="Effacer les filtres"
          (click)="clearFilters()">
          <mat-icon>
            clear
          </mat-icon>
        </button>
      </div>

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)"
        [formGroup]="filterForm">
        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'recurringOrders.list.identifier' | translate}}
              <input class="identifier-filter" (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation(); filterEnter($event, 'identifier')" matInput type="number"
                formControlName="identifier" placeholder="Filtre">
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ order.identifier }} </td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'recurringOrders.list.urgency' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')" [list]="urgencies" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>

          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.urgency"> {{ order.urgency.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'recurringOrders.list.sender' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('sender')" [list]="senders" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.sender.address"> {{ order.sender?.address.name }} </span>
            <span *ngIf="!order.sender.address"> {{ order.sender.otherAddress }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receivers">
          <th mat-header-cell *matHeaderCellDef>
            <div class="cellTh">
              {{ 'recurringOrders.list.receiver' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('receiver')" [list]="receivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.receivers.length > 1">
              <span *ngIf="order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].address.name }} (Multiples)</span>
              <span *ngIf="!order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].otherAddress }} (Multiples)</span>
            </span>
            <span *ngIf="order.receivers.length === 1">
              <span *ngIf="order.receivers[0].address"> {{ order.receivers[0].address.name }}</span>
              <span *ngIf="!order.receivers[0].address"> {{ order.receivers[0].otherAddress }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Donneur d'ordre
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('site')" [list]="sites" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.site"> {{ order.site?.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'recurringOrders.list.client' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('client')" [list]="clients" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.client"> {{ order.client.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Créé le </th>
          <td mat-cell *matCellDef="let order"> {{ order.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Heure de départ </th>
          <td mat-cell *matCellDef="let order"> {{ order.startTime }} </td>
        </ng-container>

        <ng-container matColumnDef="cronDescription">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let order"> {{ order.cronDescription }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'recurringOrders.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let order" class="tdActions">
            <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
              [matTooltip]="'recurringOrders.list.detail' | translate" (click)="onSelectOrder(order.id)">
              <mat-icon aria-label="Edit">zoom_in</mat-icon>
            </button>
            <button *ngIf="!order.isDeleted && isAdmin" mat-icon-button class="action-button" color="primary"
              [disabled]="isLoading" [matTooltip]="'recurringOrders.list.delete' | translate" (click)="delete(order)">
              <mat-icon aria-label="Edit">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let order; columns: displayedColumns;"></tr>
      </table>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
    <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
      [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>